import React from 'react'

import { Box, Grid, Link, Tooltip } from '@mui/material'
import { KYCTierLevelChip } from '../../components/chips/KYCTierLevelChip'
import { KYCStatusChip } from '../../components/chips/KYCStatusChip'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import AddIndividualKYCComponent from './AddIndividualKYCComponent'
import ResetKYCComponent from './ResetKYCComponent'
import AddInstitutionalKYCComponent from './AddInstitutionalKYCComponent'
import { type EditAssetHolderProps } from './EditAssetHolderForm'

const EditAssetHolderKycView: React.FC<EditAssetHolderProps> = ({
  assetHolder
}: EditAssetHolderProps) => {
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 12, editable: false },
    { field: 'provider', headerName: 'Provider', flex: 40, editable: false },
    // {
    //   field: 'provider',
    //   headerName: 'Provider',
    //   flex: 35,
    //   renderCell: params => (
    //     <Tooltip title={params.value}>
    //       <Chip label={params.value ?? '-'} />
    //     </Tooltip>
    //   )
    // },
    {
      field: 'tierLevel',
      headerName: 'Tier Level',
      flex: 20,
      renderCell: params => (
        <KYCTierLevelChip kycTierLevel={params.row.tierLevel}/>
      )
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 40,
      renderCell: params => (
        <KYCStatusChip kycStatus={params.row.status}/>
      )
    },
    { field: 'kycDateTime', headerName: 'Date Timestamp', flex: 30, editable: false },
    {
      field: 'manualCheckAtFormatted',
      headerName: 'Manual Check',
      flex: 35,
      editable: false,
      renderCell: params => (
        <Tooltip title={params.row.manualCheckAtFormatted}>
          <span>{params.row.manualCheckAtFormatted ?? '-'}</span>
        </Tooltip>
      )

    },
    {
      field: 'manualCheckByEmail',
      headerName: 'Manual Check By',
      flex: 40,
      editable: false,
      renderCell: params => (
        <Tooltip title={params.row.manualCheckByEmail}>
          <span>{params.row.manualCheckByEmail ?? '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'manualCheckS3FolderName',
      headerName: 'S3 Folder',
      flex: 30,
      editable: false,
      renderCell: params => (
        <Tooltip title={params.row.manualCheckS3FolderName}>
          <span>{params.row.manualCheckS3FolderName ?? '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'manualCheckReferenceUrl',
      headerName: 'ReferenceUrl',
      flex: 30,
      editable: false,
      renderCell: params => (
        <Tooltip title={params.row.manualCheckReferenceUrl}>
          <Link href={params.row.manualCheckReferenceUrl}
                target="_blank">
            {params.row.manualCheckReferenceUrl}
          </Link>
        </Tooltip>
      )
    },
    {
      field: 'narrative',
      headerName: 'Narrative',
      flex: 80,
      renderCell: params => (
        <Tooltip title={params.row.narrative}>
          <span>{params.row.narrative ?? '-'}</span>
        </Tooltip>
      )
    }

  ]

  return (
    <>
        <Box sx={{ pb: 4 }}>
          <h3>KYC Records</h3>
          <Grid container spacing={4} >
            <Grid item md={12}>
              <DataGrid rows={assetHolder.assetHolderKycResults} columns={columns} autoHeight={true} pageSize={5} rowsPerPageOptions={[5]} />
            </Grid>
          </Grid>
          <Box sx={{ pb: 4, mt: 3 }}>
          <Grid container spacing={4} rowSpacing={3}>
            <Grid item md={12}>

              <ResetKYCComponent assetHolder={assetHolder}/>
              <Box sx={{ display: 'inline-block', mr: 2 }}></Box>
              <AddInstitutionalKYCComponent assetHolder={assetHolder}/>
              <Box sx={{ display: 'inline-block', mr: 2 }}></Box>
              <AddIndividualKYCComponent assetHolder={assetHolder}/>
            </Grid>
          </Grid>
          </Box>
        </Box>

        {/* ==================================================================================================== */}

    </>
  )
}

export default EditAssetHolderKycView
